var map = {
	"./assets/banners/banner-10.jpg": "d287",
	"./assets/banners/banner-4-black.jpeg": "3c07",
	"./assets/banners/banner-4-black.jpg": "eb06",
	"./assets/banners/banner-5.jpg": "062b",
	"./assets/banners/banner-6.jpg": "ea63",
	"./assets/banners/banner-7.jpg": "fc7d",
	"./assets/banners/banner-8.jpg": "02db",
	"./assets/banners/banner-9.jpg": "bde1",
	"./assets/banners/banner12.jpg": "fdfe",
	"./assets/banners/banner13.png": "5cd4",
	"./assets/banners/banner14.png": "73a6",
	"./assets/banners/banner15.png": "3278",
	"./assets/banners/banner16.png": "ad48",
	"./assets/banners/banner3.png": "9555",
	"./assets/banners/banner4.png": "da1b",
	"./assets/banners/banner6.png": "4a48",
	"./assets/banners/banner7.png": "d70d",
	"./assets/banners/banner8.png": "4d30",
	"./assets/banners/bannerbg5.png": "680f",
	"./assets/banners/homebanner1.png": "3d33",
	"./assets/banners/homebannerbg1.png": "047f",
	"./assets/banners/homebannerbg2.png": "981d",
	"./assets/banners/homebannerbg3.png": "98e4",
	"./assets/banners/homebannerbg4.png": "94d3",
	"./assets/banners/product.png": "0c87",
	"./assets/banners/shop01.png": "1b79",
	"./assets/banners/shop02.png": "61d2",
	"./assets/banners/shop03.png": "a727",
	"./assets/common/config": "8f0e",
	"./assets/common/config.js": "8f0e",
	"./assets/icon/chang.svg": "d851",
	"./assets/icon/clock-fast.svg": "a409",
	"./assets/icon/share.svg": "af36",
	"./assets/icon/times.svg": "1499",
	"./assets/icon/web.svg": "3711",
	"./assets/icon/xcx.svg": "ca02",
	"./assets/img/404.png": "8f20",
	"./assets/img/abouts.png": "f8f5",
	"./assets/img/aboutxcj.png": "e7f5",
	"./assets/img/alwayslogo.png": "916a",
	"./assets/img/alwayspay.png": "4c57",
	"./assets/img/banner-7.png": "5543",
	"./assets/img/bannerproduct.png": "7c78",
	"./assets/img/card-payments.svg": "5c7b",
	"./assets/img/dls.png": "0e4a",
	"./assets/img/gais.png": "d827",
	"./assets/img/hzwx.png": "bb28",
	"./assets/img/icon.png": "f0fc",
	"./assets/img/issus.png": "0061",
	"./assets/img/logoblue.png": "4b70",
	"./assets/img/logofang.png": "1b9d",
	"./assets/img/logoonly.png": "8efc",
	"./assets/img/logoonly2.png": "765d",
	"./assets/img/map.png": "48dd",
	"./assets/img/pet10.png": "9835",
	"./assets/img/pet7.png": "a42a",
	"./assets/img/pet9.png": "e627",
	"./assets/img/petjy.png": "39c2",
	"./assets/img/petlifecycle.png": "0ceb",
	"./assets/img/phone1.png": "6598",
	"./assets/img/process.png": "0d4d",
	"./assets/img/product.png": "ec96",
	"./assets/img/qrcode.png": "a596",
	"./assets/img/syscw.png": "3281",
	"./assets/img/sysdd.png": "5af6",
	"./assets/img/sysgzt.png": "4d10",
	"./assets/img/syshy.png": "2f35",
	"./assets/img/sysset.png": "47b1",
	"./assets/img/syssy.png": "54ee",
	"./assets/img/sysxcx.png": "9b03",
	"./assets/img/sysyw.png": "37d4",
	"./assets/img/sysyx.png": "74c5",
	"./assets/img/syszl.png": "ed52",
	"./assets/img/whitelogo.png": "4377",
	"./assets/img/xcjgzhqrcode.jpg": "ddc6",
	"./assets/img/xcjlogo.jpeg": "2592",
	"./assets/img/xinchongjiaxcxcode.jpg": "b672",
	"./assets/logo.png": "cf05",
	"./assets/logo3.png": "d092",
	"./assets/style/iconfont1.css": "e1ba",
	"./assets/style/iconfont1.woff2": "46b7",
	"./assets/style/layout.css": "7867",
	"./assets/style/main.css": "db78",
	"./assets/webjson/webconfig": "5ba5",
	"./assets/webjson/webconfig.json": "5ba5",
	"./components/VLink": "3d7c",
	"./components/VLink.vue": "3d7c",
	"./components/banner": "b9ad",
	"./components/banner.vue": "b9ad",
	"./components/card": "ff86",
	"./components/card.vue": "ff86",
	"./components/collapes": "cddb",
	"./components/collapes.vue": "cddb",
	"./components/footer": "076e",
	"./components/footer.vue": "076e",
	"./components/header": "71c2",
	"./components/header.vue": "71c2",
	"./components/logo": "15da",
	"./components/logo.vue": "15da",
	"./components/nav": "3d01",
	"./components/nav.vue": "3d01",
	"./components/tab": "9fdc",
	"./components/tab.vue": "9fdc",
	"./layouts/Main": "8e31",
	"./layouts/Main.vue": "8e31",
	"./main": "56d7",
	"./main.js": "56d7",
	"./pages/404": "ee5d",
	"./pages/404.vue": "ee5d",
	"./pages/About": "a1d1",
	"./pages/About.vue": "a1d1",
	"./pages/Download": "993f",
	"./pages/Download.vue": "993f",
	"./pages/Ecological": "2f8a",
	"./pages/Ecological.vue": "2f8a",
	"./pages/Home": "bc13",
	"./pages/Home.vue": "bc13",
	"./pages/Product": "17be",
	"./pages/Product.vue": "17be",
	"./pages/Solution": "8f03",
	"./pages/Solution.vue": "8f03",
	"./routes": "5665",
	"./routes.js": "5665"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";